import company from './company'
import common from './common'

export default {
  company,
  common
}
